import { writable } from "svelte/store";

export const currentRoute = writable({
    name: "home",
    path: "/",
    params: {},
    queryParams: {},
});

export function setCurrentRoute(route) {
    currentRoute.set(route);
}
